import styled from "styled-components";
import { Settings } from "@styled-icons/ionicons-outline";
import { Loading } from "styles/styled-components";

export {
  PageContainer,
  PageHeader,
  PageContent,
  ButtonMini,
} from "styles/styled-components";

export const IconSetting = styled(Settings).attrs({ size: 24 })``;

export const LoadingPage = styled(Loading)`
   justify-self: center;
`;

export const HeaderButtons = styled.div`
  display: flex;
  gap: 18px;
`;
